import moment from 'moment';
import 'moment/locale/nb';

/**
 * Formats the date with moment.format.
 * (Why not just use vue-moment filter? Because the vue-moment filter pollutes the console when the value is undefined or null :/)
 * @param {string|moment} date - The value to format.
 * @param {string} format - The format string passed to moment.
 */
export function formatDate(date, format) {
    return date && date !== null && date !== undefined && date !== '' ? moment(date).format(format) : '';
}